import React, { useState } from 'react';
import {
  Grid,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  IconButton,
  Button
} from '@material-ui/core';
import { TextField } from 'formik-material-ui';
import { Formik, Form, Field } from 'formik';
import * as yup from 'yup';
import Footer from '../../layout-components/Footer';
import MailOutlineTwoToneIcon from '@material-ui/icons/MailOutlineTwoTone';
import LockTwoToneIcon from '@material-ui/icons/LockTwoTone';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import logo from '../../assets/images/wm-images/CompLogo.jpg';
import { ExampleWrapperSimple } from '../../layout-components';
import Snackbar from '../../components/Snackbar';
import api from '../../api';

export default function LivePreviewExample(props) {
  const [toast, setToast] = useState({ state: false });
  const [checked1, setChecked1] = useState(true);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange1 = (event) => {
    setChecked1(event.target.checked);
  };

  const handleSubmit = async (values) => {
    try {
      const { data } = await api.post(`/v1/auth/login`, {
        ...values,
        role: 'Customer'
      });
      localStorage.setItem('authToken', `Bearer ${data.authToken}`);
      localStorage.setItem('name', data.data.firstName);
      localStorage.setItem('email', data.data.email);
      localStorage.setItem('role', data.role);
      props.history.push('/dashboard');
    } catch (error) {
      if (
        error.response !== undefined &&
        error.response.data !== null &&
        error.response.data.errors.length !== 0
      ) {
        setToast({
          state: true,
          message: error.response.data.errors[0],
          color: 'danger'
        });
        console.log('Err', error.response.data.message);
      } else {
        setToast({
          state: true,
          message: error.response.data.errors,
          color: 'danger'
        });
        console.log('Err', error.response);
      }
    }
  };
  return (
    <>
      <Snackbar toast={toast} setToast={setToast} />
      <div className="app-wrapper bg-grey min-vh-100">
        <div className="app-main min-vh-100">
          <div className="app-content p-0">
            <div className="app-content--inner d-flex align-items-center">
              <div className="flex-grow-1 w-100 d-flex align-items-center">
                <div className="bg-composed-wrapper--content py-0">
                  <Grid item md={10} lg={8} xl={4} className="mx-auto">
                    <ExampleWrapperSimple>
                      <div className="text-center">
                        <div className="mb-5">
                          <img alt="..." src={logo} style={{ width: '70%' }} />
                        </div>
                        <h1 className="display-4 mb-4 font-weight-bold">
                          Customer Login
                        </h1>
                      </div>
                      <Formik
                        // enableReinitialize
                        validationSchema={yup.object({
                          username: yup
                            .string()
                            // .email('Invalid email address')
                            .required('Required'),
                          password: yup
                            .string()
                            // .min(8, 'Atleast 8 characters')
                            .required('Required')
                        })}
                        initialValues={{
                          username: 'admin@customer.com',
                          password: 'admin'
                        }}
                        onSubmit={handleSubmit}>
                        {({ setFieldValue, values, ...rest }) => {
                          return (
                            <Form>
                              <div>
                                <div className="mb-4">
                                  <Field
                                    component={TextField}
                                    fullWidth
                                    variant="outlined"
                                    name="username"
                                    label="Username"
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <MailOutlineTwoToneIcon />
                                        </InputAdornment>
                                      )
                                    }}
                                  />
                                </div>
                                <div className="mb-3">
                                  <Field
                                    component={TextField}
                                    fullWidth
                                    variant="outlined"
                                    name="password"
                                    label="Password"
                                    type={showPassword ? 'text' : 'password'}
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <LockTwoToneIcon />
                                        </InputAdornment>
                                      ),
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <IconButton
                                            onClick={() => {
                                              setShowPassword(!showPassword);
                                            }}>
                                            {showPassword ? (
                                              <Visibility />
                                            ) : (
                                              <VisibilityOff />
                                            )}
                                          </IconButton>
                                        </InputAdornment>
                                      )
                                    }}
                                  />
                                </div>
                                <div className="d-flex justify-content-between align-items-center font-size-md">
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={checked1}
                                        onChange={handleChange1}
                                        value="checked1"
                                        color="primary"
                                      />
                                    }
                                    label="Remember me"
                                  />
                                  <div>
                                    <a
                                      href="/recover-password"
                                      // onClick={(e) => e.preventDefault()}
                                      className="text-first">
                                      Recover password
                                    </a>
                                  </div>
                                </div>
                                <div className="text-center py-4">
                                  <Button
                                    type="submit"
                                    className="btn-second font-weight-bold w-50 my-2">
                                    Sign in
                                  </Button>
                                </div>
                              </div>
                            </Form>
                          );
                        }}
                      </Formik>
                    </ExampleWrapperSimple>
                  </Grid>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}
